import { ISchedule, WorkplaceRequestElement } from '@gettactic/api';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger
} from '@v2/components/ui/tabs';
import { WPRequestsPlaneTable } from './WPRequestsPlaneTable';
import { UsersInOffice } from './UsersInOffice';
import { useState } from 'react';
import { useTeamAttendanceFilters } from 'v2/components/TeamSchedule/hooks/useTeamAttendanceFilters';
import { useAuthenticated } from '@gettactic/hooks';
import { SelectTeams } from 'v2/components/SelectTeams';
import { DashboardEventDetailsProps } from './DashboardEventDetails';

export const AnyWorkplaceData = ({
  schedule,
  officeId,
  workplaceRequests,
  teamSchedule,
  onRequestClick,
  isOrgPrivacyEnabled
}: {
  schedule: ISchedule;
  officeId: string;
  workplaceRequests: WorkplaceRequestElement[];
  teamSchedule?: DashboardEventDetailsProps["teamSchedule"];
  onRequestClick?: (request: WorkplaceRequestElement) => void;
  isOrgPrivacyEnabled: boolean;
}) => {
  const [userCount, setUserCount] = useState<number>(0);
  
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();

  const {
    filters: dashboardFilters,
    isComponentLoading,
    setTeams
  } = useTeamAttendanceFilters({
    authenticatedUser,
    currentOffice: { id: officeId }
  });

  return (
    <Tabs defaultValue={workplaceRequests.length > 0 ? "workplaceRequests" : "users"}>
      <div className="flex items-center justify-between px-2.5 md:px-0">
        <TabsList className="font-bold">
          {!isOrgPrivacyEnabled && <TabsTrigger value="users">
            In the office ({userCount})
          </TabsTrigger>}
          {workplaceRequests.length > 0 && (
            <TabsTrigger value="workplaceRequests">
              Workplace Requests ({workplaceRequests.length})
            </TabsTrigger>
          )}
        </TabsList>
        {!isOrgPrivacyEnabled && <SelectTeams
          includeFavs={true}
          teams={dashboardFilters.teams}
          applyOnClick={true}
          onChange={(teamIds: string[] | string) => {
            const teamIdsArray = Array.isArray(teamIds) ? teamIds : [teamIds];
            setTeams(teamIdsArray);
          }}
          className=""
          disabled={isComponentLoading}
          triggerClassName="hidden md:flex mx-0 px-0"
        />}
      </div>
      <TabsContent value="users">
        {teamSchedule ? teamSchedule : isOrgPrivacyEnabled ? null : <UsersInOffice 
          officeId={officeId} 
          onUserCountChange={setUserCount}
          isRoom={false}
        />}
      </TabsContent>
      {workplaceRequests?.length > 0 && (
        <TabsContent value="workplaceRequests" className="md:px-0">
          <WPRequestsPlaneTable schedule={schedule} workplaceRequests={workplaceRequests} onRequestClick={onRequestClick} />
        </TabsContent>
      )}
    </Tabs>
  );
};
